<template>
  <fragment>
    <b-form-invalid-feedback
      v-if="isBootstrap"
      :id="id"
    >
      <template v-for="(rule, index) in ruleList">
        <div
          v-if="(rule in validation.$params) && !validation[rule]"
          :key="index"
        >
          <span v-if="rule == 'minLength'">
            {{ $t(`validator.${rule}`, [label, validation.$params[rule] ? validation.$params[rule]["min"] : '']) }}
          </span>
          <span v-else-if="rule == 'maxLength'">
            {{ $t(`validator.${rule}`, [label, validation.$params[rule] ? validation.$params[rule]["max"] : '']) }}
          </span>
          <span v-else>
            {{ $t(`validator.${rule}`, [label, validation.$params[rule]? validation.$params[rule]["min"] : '']) }}
          </span>
        </div>
      </template>
    </b-form-invalid-feedback>
    <span
      v-else
      :id="id"
      class="b-form-invalid-custom"
    >
      <span v-if="validation.$error">
        <template v-for="(rule, index) in ruleList">
          <span
            v-if="(rule in validation.$params) && !validation[rule]"
            :key="index"
          >
            <span v-if="rule == 'minLength'">
              {{ $t(`validator.${rule}`, [label, validation.$params[rule] ? validation.$params[rule]["min"] : '']) }}
            </span>
            <span v-else-if="rule == 'maxLength'">
              {{ $t(`validator.${rule}`, [label, validation.$params[rule] ? validation.$params[rule]["max"] : '']) }}
            </span>
            <span v-else>
              {{ $t(`validator.${rule}`, [label, validation.$params[rule]? validation.$params[rule]["min"] : '']) }}
            </span>
          </span>
        </template>
      </span>
    </span>
  </fragment>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue'
import { Fragment } from 'vue-fragment'

const DEFAULT_RULES = [
  'required',
  'minLength',
  'maxLength',
  'isTrueImage',
  'isValidSize',
  'requiredIf',
  'url',
  'integer',
  'isLink',
  'isUnique',
]

export default {
  name: 'BFormInvalid',
  components: { BFormInvalidFeedback, Fragment },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    label: {
      type: String,
      default: 'نام فیلد',
    },
    validator: {
      type: Object,
      required: true,
    },
    isBootstrap: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: [Array],
      default: () => DEFAULT_RULES,
    },
  },
  computed: {
    validation() {
      return this.validator && this.validator.$params ? this.validator : { $params: {}, $error: false }
    },
    ruleList() {
      return this.rules.length ? this.rules : DEFAULT_RULES
    },
  },
}
</script>
<style lang="scss" scoped>
.b-form-invalid-custom {
  font-size: 0.857rem;
  color: #ea5455;
}
</style>
